/**
 * Valid named color.
 * The mirrored version of the color intensity is the color of the same index from the end of the array.
 */
export const NAMED_COLORS = ["white", "black"] as const;

/**
 * Valid color category to be used with color intensity. For example `red-500`.
 */
export const COLOR_CATEGORIES = [
  "gray",
  "red",
  "orange",
  "yellow",
  "green",
  "teal",
  "cyan",
  "blue",
  "purple",
  "fuchsia",
] as const;

/**
 * Valid color intensity to be used as a postfix for the color name. For example `red-300`.
 * The mirrored version of the color intensity is the color of the same index from the end of the array.
 */
export const COLOR_INTENSITIES = [
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900",
] as const;

export type ColorIntensity = (typeof COLOR_INTENSITIES)[number];

export type ColorCategory = (typeof COLOR_CATEGORIES)[number];

export type ColorWithIntensity = `${ColorCategory}-${ColorIntensity}`;

export type NamedColor = (typeof NAMED_COLORS)[number];

export type Color = ColorWithIntensity | NamedColor;
